import { gatewayGetAction, gatewayPostAction, gatewayPutAction,gatewayDeleteAction } from '@/api/manage'
import { getFrontConfig, utils } from 'ow-service-component'
export default{
    // 我的收藏
    myCollection: (params) => {
        return gatewayGetAction('/service-xzyd/collection/owBizCollectionRecords/queryCollectList', params)
    },
    // 我的收藏-取消收藏
    deleCollection: (params) => {
        return gatewayDeleteAction('/service-xzyd/collection/owBizCollectionRecords/delete', params)
    },
    // 我的纠错-模块
    myModuledata: (params) => {
        return gatewayGetAction('/service-xzyd/impl/correct/queryModuleEnum', params)
    },
    // 我的纠错-查询
    myErrlist: (params) => {
        return gatewayGetAction('/service-xzyd/impl/correct/queryImplCorrectInfoList', params)
    },
    // 我的纠错-修改
    modify: (params) => {
        return gatewayPutAction('/service-xzyd/impl/correct/approve?action=edit', params)
    },
    //我的纠错-撤回
    withdraw: (params) => {
        return gatewayPutAction('/service-xzyd/impl/correct/approve?action=cancel', params)
    },
    // 我的纠错-修改-根据大厅查事项
    myQueryImpl: (params) => {
        return gatewayGetAction('/service-xzyd/impl/owBizDeptImplement/listData', params)
    },
    // 我的添加-常见问题
    myProblem: (params) => {
        return gatewayGetAction('/service-xzyd/consult/owBizKnowledgeInfo/queryImplKnowledgeInfo', params)
    },
    // 我的添加-补充说明
    myExplain: (params) => {
        return gatewayGetAction('/service-xzyd/impl/owBizDeptImplementText/queryImplAdditionalRemarks', params)
    },
    upload:() => {
        return utils.axiosUtils.concatUrl(getFrontConfig().XZYD_API, '/oss/file/upload')
    },
    // 修改头像
    updateRealname: (params) => {
        return gatewayGetAction('/service-xzyd/sys/user/updateAvatar', params)
    },
    // 获取手机验证码
    sendCaptcha: (params) => {
        return gatewayGetAction('/service-xzyd/sys/user/getPhoneCode', params)
    },
    // 修改手机号
    editPhone: (params) => {
        return gatewayGetAction('/service-xzyd/sys/user/updatePhone', params)
    },
    // 修改密码
    editPassword: (params) => {
        return gatewayPutAction('/service-xzyd/sys/user/updatePassword', params)
    },
    
}